<tool-drawer-container [shouldShowToggleBtn]="false">
  <tool-header
    class="tool-header"
    headerTitle="FTIC Course DWF & APR"
    [pathBreadcrumbs]="
      toolListService.getHelpPagePathBreadcrumbs('ftic_course')
    "
  ></tool-header>

  <div class="tool-content-container main-content">
    <div class="tool-description">
      Below are the step by step instructions on how to use FTIC Course DWF &
      APR Tool. The FTIC Course DWF & APR Tool identifies DWF for the top 25
      most enrolled courses, APR rate by grade, and trends for the selected
      course.
    </div>

    <div class="tool-div">
      <div class="left-align-div">
        <h1 class="h1-header">
          Admin Support Section
          <i class="fa-solid fa-arrow-right"></i> FTIC Course DWF & APR
        </h1>

        <div class="buttons-nav">
          <div class="example-button-row">
            <nav-page-link
              text="FTIC Course DWF & APR Filter Guide"
              targetId="formguide"
              tooltipMessage="Navigate down"
            ></nav-page-link>
            <span> &nbsp; | &nbsp; </span>
            <nav-page-link
              text="FTIC Course DWF & APR Graphs Result"
              targetId="results"
              tooltipMessage="Navigate down"
            ></nav-page-link>
          </div>
        </div>

        <!---------- FTIC Course DWF & APR Tool At First Glance ---------->
        <h3 class="h3-second-header">
          FTIC Course DWF & APR Tool At First Glance
        </h3>

        <ol class="ordered-list">
          <li>
            Once you get to the page, you will be able to see something like the
            image below in Figure 42.
          </li>
        </ol>

        <div>
          <br />
          <img
            class="small-pics"
            [(src)]="env['logo_paths']['helpPageFTICCourseDWFAPR42']"
            alt=""
          />
          <p class="picture-caption">
            Figure 42: FTIC Course DWF & APR Tool Page
          </p>
        </div>

        <div id="formguide"></div>
        <br />
        <mat-divider></mat-divider>
        <br />
      </div>

      <!---------- FTIC Course DWF & APR Form Guide ---------->
      <div class="left-align-div">
        <h3 class="h3-second-header">FTIC Course DWF & APR Form Submission</h3>

        <ol class="unordered-list">
          <li>Select a Cohort Year (2018, 2019, 2020, 2021, 2022, 2023)</li>
          <li>
            Select a College (All; Lewis Bear Jr College of Business; College of
            Arts, Social Sciences and Humanities; Usha Kundu, MD College of
            Health; Hal Marcus of College of Science and Engineering; School of
            Education; No College Designated)
          </li>
          <li>Select a Program</li>
          <li>Select the range for the High School GPA (0-5.00)</li>
          <li>
            Select a UWF Year (Ex. UWFYear1, UWFYear2, UWFYear3, UWFYear4)
          </li>
          <li>Select a Term (Ex. 202208, 202301, 202305)</li>
          <li>Select a Course Number (Example: MAC2311)</li>
          <li>Click the submit button</li>
        </ol>
        <div>
          <p></p>
          <img
            class="set-img-width-sm"
            [(src)]="env['logo_paths']['helpPageFTICCourseDWFAPR43']"
            alt=""
          />
          <p class="picture-caption">
            Figure 43: Default inputs for FTIC Course DWF & APR input fields
          </p>
        </div>
      </div>

      <!--------------- Results After Form Submission Explanation --------------->
      <div class="left-align-div" id="results">
        <br />
        <mat-divider></mat-divider>
        <br />

        <h3 class="h3-second-header">Results after Form Submission</h3>

        <ul class="unordered-list">
          <li>
            After you change the form fields’ values to your desired values, the
            form will automatically submit itself.
          </li>
          <li>
            The results will be regenerated based on the new input values.
          </li>
          <li>
            You can also click on the colored boxes that’s below the graphs to
            remove any line/bar on the graphs based on the color.
          </li>
          <div>
            <p></p>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageFTICCourseDWFAPR44']"
              alt=""
            />
            <p class="picture-caption">
              Figure 44: FTIC Course DWF & APR graph
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageFTICCourseDWFAPR44a']"
              alt=""
            />
            <p class="picture-caption">
              Figure 44a: FTIC Course DWF & APR additional graphs
            </p>
          </div>
          <div>
            <p></p>
            <img
              class="set-img-width-med"
              [(src)]="env['logo_paths']['helpPageFTICCourseDWFAPR44b']"
              alt=""
            />
            <p class="picture-caption">
              Figure 44b: FTIC Course DWF & APR additional graphs
            </p>
          </div>
        </ul>
      </div>
    </div>
  </div>

  <related-links
    class="right-sidenav"
    [links]="
      toolListService.getAdminSupportRelatedLinkBasedOnTool(
        'FTIC Course DWF & APR',
        true
      )
    "
  ></related-links>
</tool-drawer-container>
